<template>
  <div class="inventory-workflow">
    <SearchBar ref="searchbar" label="Search for product" clearOnSearch="true" @search="search = $event; load();" />

    <v-card class="inventory-card" outlined>
      <div v-if="hasProduct" class="inventory-card__content">
        <div class="inventory-card__header">
          <div>
            <span class="inventory-card__eyebrow">Stock adjustment</span>
            <h2>{{ product.name }}</h2>
            <p>{{ product.description }}</p>
          </div>
          <v-chip small color="primary" text-color="white">
            Current {{ product.currentStock }}
          </v-chip>
        </div>

        <div class="stock-grid">
          <div class="stock-metric">
            <span>Min</span>
            <strong>{{ product.minStock }}</strong>
          </div>
          <div class="stock-metric">
            <span>Max</span>
            <strong>{{ product.maxStock }}</strong>
          </div>
          <div class="stock-metric">
            <span>Current</span>
            <strong>{{ product.currentStock }}</strong>
          </div>
        </div>

        <div class="inventory-card__actions">
          <v-text-field
            ref="stockField"
            v-model="qty"
            type="number"
            label="Quantity"
            outlined
            dense
            hide-details
          ></v-text-field>
          <v-btn class="save-btn" type="button" color="success" depressed :loading="isLoading" @click="save">
            Save
          </v-btn>
        </div>
      </div>

      <div v-else class="inventory-empty">
        <v-icon>mdi-barcode-scan</v-icon>
        <h2>No product selected</h2>
      </div>
    </v-card>
  </div>
</template>

<script>
import SearchBar from '@/components/SearchBar.vue';
import { productService } from '@/services';

export default {
  name: 'Inventory',
  components: {
    SearchBar
  },
  data: () => ({
    isLoading: false,
    search: "",
    product: {
      name: "",
      description: "",
      maxStock: 0,
      minStock: 0,
      currentStock: 0
    },
    qty: 0,
  }),
  computed: {
    hasProduct() {
      return this.product && this.product.name !== "";
    }
  },
  methods: {
    reset: function() {
      this.product = {
        name: "",
        description: "",
        maxStock: 0,
        minStock: 0,
        currentStock: 0
      };

      this.qty = 0;
    },
    load: async function() {
      this.isLoading = true;
      this.product = await productService.getByBarcode(this.search);
      this.isLoading = false;

      if (this.hasProduct) {
        this.$nextTick(() => {
          if (this.$refs.stockField) {
            this.$refs.stockField.focus();
          }
        });
      }
    },
    save: async function() {
      this.isLoading = true;
      this.product.currentStock = parseInt(this.product.currentStock) + parseInt(this.qty);
      await productService.update(this.product);
      this.isLoading = false;
      this.reset();

      this.$nextTick(() => {
        if (this.$refs.searchbar) {
          this.$refs.searchbar.focus();
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.inventory-workflow {
  display: grid;
  gap: 14px;
  max-width: 720px;
}

.inventory-card {
  padding: 18px;
}

.inventory-card__header {
  display: grid;
  gap: 14px;
  margin-bottom: 18px;

  h2 {
    color: #111827;
    font-size: 24px;
    font-weight: 800;
    line-height: 1.15;
    margin: 4px 0 0;
  }

  p {
    color: #64748b;
    margin: 6px 0 0;
  }
}

.inventory-card__eyebrow {
  color: #0f766e;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.stock-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr;
  margin-bottom: 18px;
}

.stock-metric {
  background: #f8fafc;
  border: 1px solid #dfe7ef;
  border-radius: 8px;
  padding: 12px;

  span {
    color: #64748b;
    display: block;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0;
    text-transform: uppercase;
  }

  strong {
    color: #111827;
    display: block;
    font-size: 24px;
    margin-top: 2px;
  }
}

.inventory-card__actions {
  display: grid;
  gap: 10px;
}

.inventory-empty {
  align-items: center;
  color: #64748b;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 220px;
  text-align: center;

  .v-icon {
    color: #0f766e;
    font-size: 42px;
    margin-bottom: 12px;
  }

  h2 {
    color: #334155;
    font-size: 20px;
    font-weight: 800;
    margin: 0;
  }
}

@media (min-width: 640px) {
  .inventory-card__header {
    align-items: start;
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .stock-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .inventory-card__actions {
    align-items: center;
    grid-template-columns: minmax(0, 1fr) 140px;
  }
}
</style>
